import $ from "jquery"

$(function() {
    const $menu = $("#overlaymenu");
    const $toggleButton = $("header .btnmenu");
    const $body = $("body");

    $toggleButton.on("click", toggleMenu);
    $menu.find(".ctrclosebtn .icon").on("click", toggleMenu);

    function toggleMenu() {
        const menuVisible = $menu.hasClass("visible");
        if(menuVisible) {
            hideMenu();
        } else {
            showMenu();
        }
    }

    function showMenu() {
        $menu.addClass("visible");
        $body.addClass("overlaymenuvisible");
    }

    function hideMenu() {
        $menu.removeClass("visible");
        $body.removeClass("overlaymenuvisible");
    }

    function enhanceHtml() {
        $menu.find("li.hassubmenu").append('<svg class="icon icon-menuarrowdown"><use xlink:href="#icon-menuarrowdown"></use></svg>');
    }
    enhanceHtml();
});
